import axios from 'axios';

/**
 * Modo Agente (F3, DEMO) — cliente de /api/agents en investments-api.
 * Todo aqui es plata de PRACTICA (ficticia): crear bot, fondear, pausar, diario.
 */
const AGENTS_API = axios.create({
  baseURL: import.meta.env.VITE_INVESTMENTS_API_URL || 'http://localhost:5001',
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

AGENTS_API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function getAgentCatalog() {
  const { data } = await AGENTS_API.get('/api/agents/catalog');
  return data.data;
}

export async function getMyAgents() {
  const { data } = await AGENTS_API.get('/api/agents');
  return data.data;
}

export async function createAgent({ nombre, preset }) {
  const { data } = await AGENTS_API.post('/api/agents', { nombre, preset });
  return data.data;
}

export async function fundAgent(id, monto) {
  const { data } = await AGENTS_API.post(`/api/agents/${id}/fondear`, { monto });
  return data.data;
}

export async function withdrawAgent(id, monto) {
  const { data } = await AGENTS_API.post(`/api/agents/${id}/retirar`, { monto });
  return data.data;
}

export async function pauseAgent(id) {
  const { data } = await AGENTS_API.post(`/api/agents/${id}/pausar`);
  return data.data;
}

export async function resumeAgent(id) {
  const { data } = await AGENTS_API.post(`/api/agents/${id}/reanudar`);
  return data.data;
}

export async function getAgentDiary(id) {
  const { data } = await AGENTS_API.get(`/api/agents/${id}/diario`);
  return data.data;
}

/** Diario canónico de IAs enchufadas (MCP / Salomón). Mismo cliente que getMyAgents. */
export async function getDiarioExterno() {
  const { data } = await AGENTS_API.get('/api/agents/diario-externo');
  return data.data;
}

export async function getAgentLibrary() {
  const { data } = await AGENTS_API.get('/api/agents/biblioteca');
  return data.data;
}

export async function setAgentMandato(id, tipo) {
  const { data } = await AGENTS_API.post(`/api/agents/${id}/mandato`, { tipo });
  return data.data;
}

export async function enviarSmsMandato(id) {
  const { data } = await AGENTS_API.post(`/api/agents/${id}/mandato/sms`);
  return data.data;
}

export async function verificarSmsMandato(id, codigo) {
  const { data } = await AGENTS_API.post(`/api/agents/${id}/mandato/sms/verificar`, { codigo });
  return data.data;
}

/** Propuestas de bots en pide_permiso (carta: aprobar o descartar). */
export async function getPropuestasBots() {
  const { data } = await AGENTS_API.get('/api/agents/propuestas');
  return data.data;
}

export async function aprobarPropuestaBot(id) {
  const { data } = await AGENTS_API.post(`/api/agents/propuestas/${id}/aprobar`);
  return data.data;
}

export async function descartarPropuestaBot(id) {
  const { data } = await AGENTS_API.post(`/api/agents/propuestas/${id}/descartar`);
  return data;
}

export function apiError(e, fallback) {
  return e?.response?.data?.message || fallback;
}
